<script setup>
import { computed } from 'vue'

const props = defineProps({
    // JSON content of the `banner-alert` DataItem.
    // Shape: { active: bool, message: string, type?: 'warning'|'error'|'info'|'success', link?: { url, label } }
    banner: { type: Object, default: null },
})

const isActive = computed(() => Boolean(props.banner?.active && props.banner?.message))

// Per-type styling of the top bar. Defaults to `warning`.
const styles = {
    warning: 'bg-amber-500 text-white',
    error: 'bg-red-700 text-white',
    info: 'bg-blue-600 text-white',
    success: 'bg-green-600 text-white',
}

const barClass = computed(() => styles[props.banner?.type] ?? styles.warning)
</script>

<template>
    <div v-if="isActive" class="py-2.5" :class="barClass" role="alert">
        <div class="container max-w-7xl flex items-center justify-center gap-2 text-center">
            <icon name="alert" class="size-4 flex-none"></icon>
            <span class="font-medium text-xs md:text-sm" v-html="banner.message"></span>
            <a
                v-if="banner.link && banner.link.url"
                :href="banner.link.url"
                class="font-semibold text-xs md:text-sm underline underline-offset-2 hover:opacity-80 transition-opacity duration-150 whitespace-nowrap"
            >
                {{ banner.link.label || 'Meer info' }}
            </a>
        </div>
    </div>
</template>
